


import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { SKIP_LOADER_HEADER } from './../loader.interceptor';
import { USessionService } from './usession.service';
import { StaticApis } from './../shared/corporate';
import { environment } from './../environments/environment';
import { CommonService } from '@ideabytes/groupbenefitz_common_ui';

// const httpOptions = {
//   headers: new HttpHeaders({
//     'Accept': "application/json",
//     'Content-Type': 'application/json',
//     'tenantid': 'bfciricle_canada_prod'

//   })
// };


@Injectable({ providedIn: 'root' })
export class CorporateService {
  headers: any;
  headers1: any;
  CONFIG_DATA: any; 
  Authorization:any;

  private personalinfo: string = `${environment.app.grp}${StaticApis.personalinfo}`;
  private personalinfoV5: string = `${environment.app.grp}${StaticApis.personalinfoV5}`;
  private genericPersonalinfoV5: string = `${environment.app.grp}${StaticApis.genericPersonalinfoV5}`;
  private customerACH: string = `${environment.app.grp}${StaticApis.customerACH}`;
  private updatePayment: string = `${environment.app.grp}${StaticApis.updatePayment}`;
  private validationdata: string = `${environment.app.grp}${StaticApis.validationdata}`;
  private validationdataV5: string = `${environment.app.grp}${StaticApis.validationdataV5}`;
  private genericValidationdataV5: string = `${environment.app.grp}${StaticApis.genericValidationdataV5}`;
  private draftvalidationV5: string = `${environment.app.grp}${StaticApis.draftValidationV5}`;
  private nhlaaLockerRoomSync: string = `${environment.app.grp}${StaticApis.nhlaaLockerRoomSignupSync}`;
  private reportNoPlansUrl: string = `${environment.app.grp}${StaticApis.reportNoPlans}`;



  private configData: string = `${environment.app.grp}${StaticApis.configData}`;
  private configDataCorporate: string = `${environment.app.grp}${StaticApis.configDataCorporate}`;


  private termsandconditionsvalue: string = `${environment.app.grp}${StaticApis.termsandconditionsvalue}`;
  private plansdetails: string = `${environment.app.grp}${StaticApis.plansdetails}`;
  private paymentdetails: string = `${StaticApis.paymentdetails}`;
  private getbanknamesvalues: string = `${environment.app.grp}${StaticApis.getbanknames}`;

  private bankdetailsregistervalues: string = `${environment.app.grp}${StaticApis.bankdetailsregistervalues}`;

  private addresscheck: string = `${environment.app.grp}${StaticApis.addresscheck}`;
  private signatureformat: string = `${environment.app.grp}${StaticApis.signatureformat}`;
  private bankvoidcheck: string = `${environment.app.grp}${StaticApis.bankvoidcheck}`;
  private padAggrement: string = `${environment.app.grp}${StaticApis.padAggrement}`;
  private padsignatureaggrement: string = `${environment.app.grp}${StaticApis.padsignatureaggrement}`;

  private AuthorizeProfile: string = `${environment.app.authorizePortal}${StaticApis.profileCreation}`;
  
  private AuthorizePaymentProfile: string = `${environment.app.authorizePortal}${StaticApis.paymentProfileCreation}`;

  private AuthorizeNetPayment: string = `${environment.app.grp}${StaticApis.authNetPayment}`;
  private AuthorizeChargeNow: string = `${environment.app.authorizePortal}${StaticApis.chargeNow}`;
  private AuthorizeNetMail: string = `${environment.app.authorizePortal}${StaticApis.authNetMail}`;
  private AuthorizeNetRecordUpdate: string = `${environment.app.grp}${StaticApis.authNetPayment}`;

  private savePlanDetails: string = `${environment.app.grp}${StaticApis.saveplan}`;








  constructor(private http: HttpClient, private commonSerivce: CommonService, private _uSession: USessionService) {
    // this.headers = environment.headers
    this.headers =
{
    'Accept': "application/json",
    'Content-Type': 'multipart/form-data'
  }


  }

  // nhlaaRegistrationId is stored at step-1 validation; NHLAA needs it back on
  // registration. Absent for every other signup, so nothing is added.
  private withNhlaaRegistrationId(data: any): any {
    const id = sessionStorage.getItem('nhlaaRegistrationId');
    return id ? { ...data, nhlaaRegistrationId: id } : data;
  }

  customerAch(data:any): Observable<any> {
    // var Headers = this.headers;
    //return this.http.post<any>(this.loginApiEndPoint, data, httpOptions)
    return this.http.post(this.customerACH,data,{
      // headers: Headers,
    });

    }

    updatepayment(data:any): Observable<any> {
      // var Headers = this.headers;
      //return this.http.post<any>(this.loginApiEndPoint, data, httpOptions)
      return this.http.post(this.updatePayment,data,{
        // headers: Headers,
      });

      }

  login1(data:any): Observable<any> {
    // var Headers = this.headers;
    //return this.http.post<any>(this.loginApiEndPoint, data, httpOptions)
    return this.http.post(this.personalinfo,this._uSession.attach(data),{
      // headers: Headers,
    });

    }
  loginV5(data:any): Observable<any> {
    // var Headers = this.headers;
    //return this.http.post<any>(this.loginApiEndPoint, data, httpOptions)
    return this.http.post(this.personalinfoV5,this.withNhlaaRegistrationId(this._uSession.attach(data)),{
      // headers: Headers,
    });

    }
    genericLoginV5(data:any): Observable<any> {
    // var Headers = this.headers;
    //return this.http.post<any>(this.loginApiEndPoint, data, httpOptions)
    return this.http.post(this.genericPersonalinfoV5,this.withNhlaaRegistrationId(this._uSession.attach(data)),{
      // headers: Headers,
    });

    }
    validation(data:any): Observable<any> {
      // var Headers = this.headers;
      //return this.http.post<any>(this.loginApiEndPoint, data, httpOptions)
      return this.http.post(this.validationdata,this._uSession.attach(data),{
        // headers: Headers,
      });

      }
    validationV5(data:any): Observable<any> {
      // var Headers = this.headers;
      //return this.http.post<any>(this.loginApiEndPoint, data, httpOptions)
      return this.http.post(this.validationdataV5,this._uSession.attach(data),{
        // headers: Headers,
      });

      }
      genericValidationV5(data:any): Observable<any> {
      // var Headers = this.headers;
      //return this.http.post<any>(this.loginApiEndPoint, data, httpOptions)
      return this.http.post(this.genericValidationdataV5,this._uSession.attach(data),{
        // headers: Headers,
      });

      }
    // Reports that the plan selection step came up empty for this applicant.
    // `data` is { customer: {...}, form: {...} }.
    reportNoPlans(data:any): Observable<any> {
      return this.http.post(this.reportNoPlansUrl,data,{
        // headers: Headers,
      });

      }
    // NHLAA Locker Room sign-in. `data` is { session, timestamp } — see
    // docs/nhlaa-locker-room-session.md for how the backend decodes `session`.
    nhlaaLockerRoomSignupSync(data:any): Observable<any> {
      return this.http.post(this.nhlaaLockerRoomSync,data,{
        // headers: Headers,
      });

      }
    draftValidationV5(data:any): Observable<any> {
      // var Headers = this.headers;
      //return this.http.post<any>(this.loginApiEndPoint, data, httpOptions)
      return this.http.post(this.draftvalidationV5,this._uSession.attach(data),{
        // headers: Headers,
      });

      }


    getbanknames(data:any): Observable<any> {
      // var Headers = this.headers;
      //return this.http.post<any>(this.loginApiEndPoint, data, httpOptions)
      return this.http.post(this.getbanknamesvalues,data,{
        // headers: Headers,
      });

      }
      // bankdetailsregister(data,formData): Observable<any> {
      //   var Headers = this.headers;
      //   return this.http.post(this.bankdetailsregistervalues+"/"+data+"/register",formData,{
      //     headers: Headers,
      //   });

      //   }


      //   bankvoidcheckupload(id,data): Observable<any> {
      //     // var Headers = this.headers;
      //     return this.http.post(this.bankvoidcheck+"/"+id+"/bank/cheque",data,{
      //       // headers: Headers,
      //     });

      //     }



    // getDataConfig(id): Observable<any> {
    //   // var Headers = this.headers;
    //   //return this.http.post<any>(this.loginApiEndPoint, data, httpOptions)
    //   return this.http.get(this.configData+"/"+id,{
    //     // headers: Headers,
    //   });

    //   }
      getDataConfig(formlink:any): Observable<any> {
        // var Headers = this.headers;
        //return this.http.post<any>(this.loginApiEndPoint, data, httpOptions)
        return this.http.get(this.configData+"?"+"formLink=/"+formlink,{
          // headers: Headers,
        });

        }
  getCorporateData(formlink: any,tierUniqueId:any,uniqueid:any): Observable<any> {
          // var Headers = this.headers;
          //return this.http.post<any>(this.loginApiEndPoint, data, httpOptions)
    return this.http.get(this.configDataCorporate + "?" + "formLink=/" + formlink + "&" + "tierUniqueId=" + tierUniqueId + "&" + "userUniqueId=" + uniqueid ,{
            // headers: Headers,
          });

          }




      getplans(provinceid:any,status:any): Observable<any> {
        // var Headers = this.headers;
        //return this.http.post<any>(this.loginApiEndPoint, data, httpOptions)
        return this.http.post(this.plansdetails+provinceid+"/"+status+"/"+"plansProductsDetailed",{
          // headers: Headers,
        });

        }
        payment(data:any): Observable<any> {
          // var Headers = this.headers;
          //return this.http.post<any>(this.loginApiEndPoint, data, httpOptions)
          return this.http.post(this.paymentdetails,data,{
            // headers: Headers,
          });

          }

          padaddgrementdetails(data:any): Observable<any> {
            // var Headers = this.headers;
            //return this.http.post<any>(this.loginApiEndPoint, data, httpOptions)
            return this.http.post(this.padAggrement,data,{
              // headers: Headers,
            });

            }
            padsignature(data:any): Observable<any> {
              // var Headers = this.headers;
              //return this.http.post<any>(this.loginApiEndPoint, data, httpOptions)
              return this.http.post(this.padsignatureaggrement,data,{
                // headers: Headers,
              });

              }


        termsandconditions(): Observable<any> {
          // var Headers = this.headers;
          //return this.http.post<any>(this.loginApiEndPoint, data, httpOptions)
          return this.http.get(this.termsandconditionsvalue,{
            // headers: Headers,
          });

          }

          addresscheckvalidation(data:any): Observable<any> {
            // var Headers = this.headers;
            //return this.http.post<any>(this.loginApiEndPoint, data, httpOptions)
            return this.http.post(this.addresscheck,data,{
              // headers: Headers,
            });

            }
            signaturecheck(data:any): Observable<any> {

              return this.http.patch(this.signatureformat,data,{
                // headers: Headers,
              });

              }

              authorizeProfileCreation(data:any): Observable<any> {
                // var Headers = this.headers;
                //return this.http.post<any>(this.loginApiEndPoint, data, httpOptions)
                return this.http.post(this.AuthorizeProfile,data,{
                  // headers: Headers,
                });
            
                }

                authorizePaymentProfileCreation(data:any): Observable<any> {
                  // var Headers = this.headers;
                  //return this.http.post<any>(this.loginApiEndPoint, data, httpOptions)
                  return this.http.post(this.AuthorizePaymentProfile,data,{
                    // headers: Headers,
                  });
              
                  }

                  authorizeChargeNow(data:any): Observable<any> {
                    // var Headers = this.headers;
                    //return this.http.post<any>(this.loginApiEndPoint, data, httpOptions)
                    return this.http.post(this.AuthorizeChargeNow,data,{
                      // headers: Headers,
                    });
                
                    }

                  authorizeNetPaymentRecord(data:any): Observable<any> {
                    // var Headers = this.headers;
                    //return this.http.post<any>(this.loginApiEndPoint, data, httpOptions)
                    return this.http.post(this.AuthorizeNetPayment,data,{
                      // headers: Headers,
                    });
                
                    }

                    updateAuthorizeNetRecord(id: number, payload: any) {
                      return this.http.patch(`${this.AuthorizeNetPayment}/${id}`, payload);
                    }

                    sendEmail(payload: any){
                      return this.http.patch(`${this.AuthorizeNetMail}`, payload);
                    }

                    updateAuthorizeNetCustomerId(recordId: number, customerId: number) {
                      return this.http.patch(`${this.AuthorizeNetRecordUpdate}/${recordId}/update-customerId`, {
                        customerId: customerId
                      });
                    }

  // Background bookkeeping — the member is not waiting on it, so it does not
  // raise the global loader. The interceptor strips the header before sending.
  savePlan(data:any): Observable<any> {
    return this.http.post(this.savePlanDetails,this._uSession.attach(data),{
      headers: new HttpHeaders().set(SKIP_LOADER_HEADER, 'true'),
    });
  }

  submitReportLog(apiUrl: any, obj: any) {
    console.log('submitReportLog', apiUrl);
    // system details
    let systemDetails = {
      platform: navigator.platform,
      language: navigator.language,
      screenWidth: window.screen.width,
      screenHeight: window.screen.height,
      userAgent: navigator.userAgent
    }
    obj.systemDetails = JSON.stringify(systemDetails);
    obj.browser = navigator.userAgent;
    obj.sessionDetails = JSON.stringify({ timestamp: sessionStorage.getItem('timeStamp') });

    try {
      this.http.post(
        apiUrl + 'common/report/add-report',
        // 'http://[::1]:3004/api/ep/admin/report/add-report',
        obj,
      ).subscribe((response: any) => {
        if (response.status == 200) {
          console.log('add report response 200', response);
        } else {
          console.log('add report response not 200', response);
        }
      })
    } catch (error) {
      console.error('error submitting report log', error)
    }
  }

  buildActivityLogObject(obj: any, submit: boolean = false) {
    let activity: any = {};
    activity.portal = 'SIGNUP';

    activity.effectedUserType = 'CUSTOMER';
    activity.effectedUserId = obj?.effectedUserId ?? sessionStorage.getItem('customerId');

    activity.changedById = obj?.effectedUserId ?? sessionStorage.getItem('customerId');
    activity.changedByUserName = JSON.parse(sessionStorage.getItem('data')??'{}')?.email;

    activity.url = obj?.url ?? undefined;
    activity.action = obj?.action ?? undefined;
    activity.requestMethod = obj?.requestMethod;
    activity.requestBody = JSON.stringify(obj?.requestBody ?? {});
    activity.status = obj?.status ?? undefined;
    activity.response = JSON.stringify(obj?.response ?? {});
    activity.responseSummary = obj?.responseSummary ?? undefined;

    if (submit) {
      this.commonSerivce.submitActivityLog(environment?.app?.commonurl, activity, environment?.app?.grp);
    }
  }
}
